export default __webpack_public_path__ + "static/media/PrintedMaterial1.216208c1.png";